import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export function useQuery() {
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  return query;
}

export function useQueryParam(paramName: string, defaultValue = '') {
  return useQuery().get(paramName) || defaultValue;
}
